import { useState } from "react";
import {
  Calendar,
  Search,
  Filter,
  TrendingUp,
  Users,
  DollarSign,
  Percent,
  FileText,
  Printer,
  Eye,
  Download,
} from "lucide-react";
import {
  LineChart,
  BarChart,
  PieChart,
} from "../../components/facturacion/charts";
import { add, format } from "date-fns";
import ModalDetalle from "../../components/facturacion/modal-detalle";
import Alerts from "../../components/Alerts/Alerts";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import * as XLSX from 'xlsx';

const mockAccountData = [
  {
    id: "57",
    eventName: "La Puta Mejor Embalsamada",
    venueName: "Teatro La Brújula",
    responsibleEmail: "info@teatrolabrujula.com.ar",
    eventDate: "viernes, 11 de octubre de 2024 HORA: 21:30",
    ticketsSold: 4,
    subtotal: 36000,
    percentage: 100,
    amountToPay: 36000,
    cbu: "0170084540000034371146",
    cuit: "20302480746",
    email: "info@teatrolabrujula.com.ar",
    discount: 0,
    discountedTickets: 0,
  },
  {
    id: "57",
    eventName: "La Puta Mejor Embalsamada",
    venueName: "Teatro La Brújula",
    responsibleEmail: "info@teatrolabrujula.com.ar",
    eventDate: "viernes, 18 de octubre de 2024 HORA: 21:30",
    ticketsSold: 2,
    subtotal: 18000,
    percentage: 100,
    amountToPay: 18000,
    cbu: "0170084540000034371146",
    cuit: "20302480746",
    email: "info@teatrolabrujula.com.ar",
    discount: 0,
    discountedTickets: 0,
  },
  {
    id: "57",
    eventName: "La Puta Mejor Embalsamada",
    venueName: "Teatro La Brújula",
    responsibleEmail: "info@teatrolabrujula.com.ar",
    eventDate: "viernes, 25 de octubre de 2024 HORA: 21:30",
    ticketsSold: 5,
    subtotal: 45000,
    percentage: 100,
    amountToPay: 45000,
    cbu: "0170084540000034371146",
    cuit: "20302480746",
    email: "info@teatrolabrujula.com.ar",
    discount: 0,
    discountedTickets: 0,
  },
  {
    id: "57",
    eventName: "La Puta Mejor Embalsamada",
    venueName: "Teatro La Brújula",
    responsibleEmail: "info@teatrolabrujula.com.ar",
    eventDate: "viernes, 8 de noviembre de 2024 HORA: 21:30",
    ticketsSold: 1,
    subtotal: 9000,
    percentage: 100,
    amountToPay: 9000,
    cbu: "0170084540000034371146",
    cuit: "20302480746",
    email: "info@teatrolabrujula.com.ar",
    discount: 0,
    discountedTickets: 0,
  },
  {
    id: "57",
    eventName: "La Puta Mejor Embalsamada",
    venueName: "Teatro La Brújula",
    responsibleEmail: "info@teatrolabrujula.com.ar",
    eventDate: "viernes, 15 de noviembre de 2024 HORA: 21:30",
    ticketsSold: 2,
    subtotal: 18000,
    percentage: 100,
    amountToPay: 18000,
    cbu: "0170084540000034371146",
    cuit: "20302480746",
    email: "info@teatrolabrujula.com.ar",
    discount: 0,
    discountedTickets: 0,
  },
];

const Facturacion = ({ resumen, analisis, detalles, params, setParams, fetch, setDetalles }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [selectedReport, setSelectedReport] = useState("todos");
  const [selectedSort, setSelectedSort] = useState("recent");
  const [activeTab, setActiveTab] = useState("overview");
  const [modal_detalle, setModalDetalle] = useState(false);
  const [modal_reportes, setModalReportes] = useState(false);

  const [reporte, setReporte] = useState({
    tipo_reporte: "general",
    formato: "excel",
    detalle: false,
    estado: 'ACTIVO',
    fecha_desde: null,
    fecha_hasta: null
  })

  const today = new Date();
  const day = String(today.getDate()).padStart(2, '0');
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const year = today.getFullYear();
  const filename = `reportes-facturacion-${day}${month}${year}`;


  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: "ARS",
      minimumFractionDigits: 0,
    }).format(amount);
  };

  const downloadReporte = (account) => {
    const liquidacion = [];

    if (account.evento.liquidacion.length > 0) {
      account.evento.liquidacion.forEach((liquidacionData) => {
        liquidacion.push(liquidacionData);
      });
    } else {
      liquidacion.push({
        cbu: "Sin datos",
        entidad: "Sin datos",
        email_sitio: "Sin datos",
        porcentaje: 0
      });
    }

    // Crear contenido HTML para la tabla
    let tableHTML = `
      <table border="1">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nombre Evento</th>
            <th>Nombre Sitio</th>
            <th>Email Sitio</th>
            <th>Fecha de función</th>
            <th>Entradas vendidas</th>
            <th>Subtotal</th>
            <th>Porcentaje</th>
            <th>Monto a abonar</th>
            <th>CBU</th>
            <th>CUIT/CUIL</th>
            <th>Email</th>
            <th>Descuento</th>
          </tr>
        </thead>
        <tbody>
    `;

    liquidacion.forEach((liq) => {
      const montoAbonar = account.total * (liq.porcentaje / 100);
      tableHTML += `
        <tr>
          <td>${account.evento.id}</td>
          <td>${account.evento.nombre}</td>
          <td>${account.evento.nombre_sitio}</td>
          <td>${account.evento.email_sitio}</td>
          <td>${account.fecha}</td>
          <td>${account.cantidad}</td>
          <td>${account.total}</td>
          <td>${liq.porcentaje}%</td>
          <td>${montoAbonar}</td>
          <td>${liq.cbu}</td>
          <td>${liq.entidad}</td>
          <td>${liq.email_sitio}</td>
          <td>$0</td>
        </tr>
      `;
    });

    tableHTML += `
        </tbody>
      </table>
    `;

    // Crear un blob con el contenido HTML
    const blob = new Blob([tableHTML], { type: 'application/vnd.ms-excel' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // Generar nombre del archivo
    const fechaDescarga = new Date();
    const dia = String(fechaDescarga.getDate()).padStart(2, '0');
    const mes = String(fechaDescarga.getMonth() + 1).padStart(2, '0');
    const anio = fechaDescarga.getFullYear();
    const nombreArchivo = `reporte-${account.evento.id}-${dia}${mes}${anio}.xls`;

    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const fetchReport = async (params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(
      dateString.replace(/(\d{2})\/(\d{1,2})\/(\d{4})/, "$3-$2-$1")
    );
    return date.toLocaleDateString("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const generateExcelFromReportFecha = (data, tipo) => {
    // Preparar los datos para el Excel
    const excelData = [];

    // Agregar headers
    const headers = [
      'ID',
      'Nombre Evento',
      'Nombre Sitio',
      'Email Sitio',
      'Fecha de función',
      'Entradas vendidas',
      'Subtotal',
      'Porcentaje',
      'Monto a abonar',
      'CBU',
      'CUIT/CUIL',
      'Email',
      'Descuento'
    ];

    // Procesar los datos
    data.forEach((account) => {
      const liquidacion = account.evento.liquidacion.length > 0
        ? account.evento.liquidacion
        : [{
          cbu: "Sin datos",
          entidad: "Sin datos",
          email_sitio: "Sin datos",
          porcentaje: 0
        }];

      liquidacion.forEach((liq) => {
        const montoAbonar = account.total * (liq.porcentaje / 100);

        excelData.push({
          'ID': account.evento.id,
          'Nombre Evento': account.evento.nombre,
          'Nombre Sitio': account.evento.nombre_sitio,
          'Email Sitio': account.evento.email_sitio,
          'Fecha de función': account.fecha,
          'Entradas vendidas': account.cantidad,
          'Subtotal': account.total,
          'Porcentaje': `${liq.porcentaje}%`,
          'Monto a abonar': montoAbonar,
          'CBU': liq.cbu,
          'CUIT/CUIL': liq.entidad,
          'Email': liq.email_sitio,
          'Descuento': 0
        });
      });
    });

    // Crear un nuevo libro de Excel
    const ws = XLSX.utils.json_to_sheet(excelData);

    // Ajustar el ancho de las columnas (opcional)
    const colWidths = [
      { wch: 10 }, // ID
      { wch: 30 }, // Nombre Evento
      { wch: 25 }, // Nombre Sitio
      { wch: 25 }, // Email Sitio
      { wch: 15 }, // Fecha
      { wch: 15 }, // Entradas vendidas
      { wch: 12 }, // Subtotal
      { wch: 10 }, // Porcentaje
      { wch: 15 }, // Monto a abonar
      { wch: 20 }, // CBU
      { wch: 15 }, // CUIT/CUIL
      { wch: 25 }, // Email
      { wch: 10 }  // Descuento
    ];
    ws['!cols'] = colWidths;

    // Aplicar estilos a los headers (opcional)
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_col(C) + "1";
      if (!ws[address]) continue;
      ws[address].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "CCCCCC" } },
        alignment: { horizontal: "center" }
      };
    }

    // Crear el libro de Excel
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Reporte ${tipo}`);

    // Generar el archivo Excel
    const fechaDescarga = new Date();
    const dia = String(fechaDescarga.getDate()).padStart(2, '0');
    const mes = String(fechaDescarga.getMonth() + 1).padStart(2, '0');
    const anio = fechaDescarga.getFullYear();
    const nombreArchivo = `reporte-${tipo}-${dia}${mes}${anio}.xlsx`;

    // Descargar el archivo
    XLSX.writeFile(wb, nombreArchivo);
  };

  const generateExcelFromReport = (data, tipo) => {
    // Preparar los datos para el Excel
    const excelData = [];

    // Agregar headers
    const headers = [
      'ID',
      'Fecha Compra',
      'Evento',
      'Cliente',
      'Fecha de función',
      'Precio',
      'Cant.',
      'SubTotal',
      'Cupon',
      'Descuento',
      'Total',
      'Estado',
    ];

    // Procesar los datos
    data.forEach((account) => {
      excelData.push({
          'ID': account.id,
          'Fecha Compra': formatDate(account.created_at),
          'Evento': account.evento.nombre,
          'Cliente': account.nombre_cliente,
          'Fecha de función': account.fecha,
          'Precio': account.unidad,
          'Cant.': account.cantidad,
          'SubTotal': account.cantidad * account.unidad,
          'Cupon': account.codigo_descuento,
          'Descuento': account.descuento,
          'Total':  account.cantidad * account.unidad,
          'Estado':  account.status,
        });
    });

    // Crear un nuevo libro de Excel
    const ws = XLSX.utils.json_to_sheet(excelData);

    // Ajustar el ancho de las columnas (opcional)
    const colWidths = [
      { wch: 10 }, // ID
      { wch: 30 }, // Fecha Compra
      { wch: 25 }, // Evento
      { wch: 25 }, // Cliente
      { wch: 15 }, // Fecha Funcion
      { wch: 15 }, // Precio
      { wch: 12 }, // Cant.
      { wch: 10 }, // SubTotal
      { wch: 15 }, // Cupon
      { wch: 20 }, // Descuento
      { wch: 15 }, // Total
    ];
    ws['!cols'] = colWidths;

    // Aplicar estilos a los headers (opcional)
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_col(C) + "1";
      if (!ws[address]) continue;
      ws[address].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "CCCCCC" } },
        alignment: { horizontal: "center" }
      };
    }

    // Crear el libro de Excel
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Reporte ${tipo}`);

    // Generar el archivo Excel
    const fechaDescarga = new Date();
    const dia = String(fechaDescarga.getDate()).padStart(2, '0');
    const mes = String(fechaDescarga.getMonth() + 1).padStart(2, '0');
    const anio = fechaDescarga.getFullYear();
    const nombreArchivo = `reporte-${tipo}-${dia}${mes}${anio}.xlsx`;

    // Descargar el archivo
    XLSX.writeFile(wb, nombreArchivo);
  };


  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "detalle":
        {
          setModalDetalle(value);
        }
        break;
      case "reportes":
        {
          setModalReportes(true);
        }
        break;
      case "close":
        {
          setModalDetalle(false);
          setModalReportes(false);
        }
        break;
      case "download-reporte":
        if (!reporte.fecha_desde || !reporte.fecha_hasta) {
          return Alerts({
            msg: "Alert",
            title: 'Por favor seleccione una fecha disponible',
            code: "401",
            type: "warning",
          });
          return "";
        }

        let params = {};
        if (reporte.tipo_reporte == 'general') {
          params = {
            'filter[created_at][from]': reporte.fecha_desde,
            'filter[created_at][to]': reporte.fecha_hasta,
            'filter[status]': reporte.estado,
            reporte: 1
          }
          const response = await fetchReport(params, "/reportes");
          if (response) {
            generateExcelFromReport(response, 'general');
            setModalReportes(false);
          } else {
            return Alerts({
              msg: "Alert",
              title: 'No se encontraron datos disponibles',
              code: "401",
              type: "error",
            });
          }
          return "";
        }



        if (reporte.tipo_reporte == 'por-fecha-funcion') {
          params = {
            fecha_desde: reporte.fecha_desde,
            fecha_hasta: reporte.fecha_hasta,
            status: reporte.estado,
            reporte: 1,
            per_page: 1000
          }
          const response = await fetchReport(params, "/facturacion");
          if (response) {
            generateExcelFromReportFecha(response, 'por-fecha');
            setModalReportes(false);
          } else {
            return Alerts({
              msg: "Alert",
              title: 'No se encontraron datos disponibles',
              code: "401",
              type: "error",
            });
          }
          return "";
        }
        break;
      default:
        break;
    }
  }

  const onChange = (e) => {
    switch (e.target.name) {
      case "detalle":
        {
        }
        break;
      case "tipo_reporte":
        setReporte({
          ...reporte,
          tipo_reporte: e.target.value
        });
        break;
      case "formato":
        setReporte({
          ...reporte,
          formato: e.target.value
        });
        break;
      case "fecha_desde":
        setReporte({
          ...reporte,
          fecha_desde: e.target.value
        });
        break;
      case "fecha_hasta":
        setReporte({
          ...reporte,
          fecha_hasta: e.target.value
        });
        break;
      case "includeCharts":
        setReporte({
          ...reporte,
          includeCharts: e.target.checked
        });
        break;
      case "includeDetails":
        setReporte({
          ...reporte,
          detalle: e.target.checked
        });
        break;
      default:
        break;
    }
  }

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>

      <div className="min-vh-100  p-3 p-lg-4">
        <div className="container" style={{ maxWidth: "1450px" }}>
          {/* Header */}
          <div className="row mb-4">
            <div className="col-12 col-sm-6">
              <h1 className="display-5 fw-bold text-dark mb-1">Cuentas</h1>
              <p className="text-muted">Estado de tus cuentas</p>
            </div>
            <div className="col-12 col-sm-6">
              <div className="d-flex gap-2 justify-content-sm-end">
                <button
                  className="btn btn-outline-secondary"
                  name="reportes"
                  onClick={onClick}
                >
                  <FileText size={16} className="me-2" />
                  Reportes
                </button>
                <button className="btn btn-outline-secondary d-none">
                  <Printer size={16} className="me-2" />
                  Imprimir
                </button>
                <label className="btn btn-outline-secondary d-none">
                  <Download size={16} className="me-2" />
                  Exportar
                  <ReactHTMLTableToExcel
                    id="buttonDownloadExcel"
                    className="d-none btn btn-outline-success rounded-pill w-100 rounded-pill fs-7 p-0 m-0 px-2 py-1"
                    table="reportes-facturacion"
                    filename={filename}
                    sheet="pagina 1"
                    buttonText="Exportar tabla actual"
                  />
                </label>
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h6 className="card-subtitle text-muted mb-0">
                      Total de ventas
                    </h6>
                    <div className="p-2 bg-success bg-opacity-10 rounded-circle">
                      <DollarSign size={20} className="text-success" />
                    </div>
                  </div>
                  <h2 className="fw-bold mb-2">
                    {formatCurrency(resumen["total-ventas"])}
                  </h2>
                  <small className="text-success d-flex align-items-center">
                    <TrendingUp size={12} className="me-1" />
                    {resumen['porcentaje-mes-venta']}% vs el mes pasado
                  </small>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h6 className="card-subtitle text-muted mb-0">
                      Total de entradas
                    </h6>
                    <div className="p-2 bg-primary bg-opacity-10 rounded-circle">
                      <Users size={20} className="text-primary" />
                    </div>
                  </div>
                  <h2 className="fw-bold mb-2">
                    {resumen["total-entradas"].toLocaleString()}
                  </h2>
                  <small className="text-primary d-flex align-items-center">
                    <TrendingUp size={12} className="me-1" />
                    {resumen['porcentaje-mes-cantidad']}% vs el mes pasado
                  </small>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 mb-3">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h6 className="card-subtitle text-muted mb-0">
                      Total de descuento
                    </h6>
                    <div className="p-2 bg-warning bg-opacity-10 rounded-circle">
                      <Percent size={20} className="text-warning" />
                    </div>
                  </div>
                  <div className="mb-2">
                    <small className="text-muted d-block">
                      Bruto {formatCurrency(resumen["total-ventas"])}
                    </small>
                    <h2 className="fw-bold mb-0">
                      Descontado {formatCurrency(resumen["total-descuento"])}
                    </h2>
                  </div>
                  <small className="text-warning d-flex align-items-center">
                    <TrendingUp size={12} className="me-1" />
                    {(
                      (resumen["total-descuento"] / resumen["total-ventas"]) *
                      100
                    ).toFixed(1)}
                    % del total
                  </small>
                </div>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="mb-4">
            <ul className="nav nav-tabs" id="accountTabs" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "overview" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("overview")}
                  type="button"
                >
                  Resumen
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "details" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("details")}
                  type="button"
                >
                  Detalles
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "analytics" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("analytics")}
                  type="button"
                >
                  Análisis
                </button>
              </li>
            </ul>

            <div className="tab-content mt-4" id="accountTabsContent">
              {/* Overview Tab */}
              {activeTab === "overview" && (
                <div className="tab-pane fade show active">
                  <div className="row">
                    <div className="col-12 col-lg-6 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="card-title mb-1">
                            Ingresos Mensuales
                          </h5>
                          <p className="card-text text-muted small mb-0">
                            Evolución de ingresos en los últimos 6 meses
                          </p>
                        </div>
                        <div className="card-body">
                          <div style={{ height: "300px" }}>
                            <LineChart data={resumen["ingresos-mensuales"]} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-6 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="card-title mb-1">Venta de Entradas</h5>
                          <p className="card-text text-muted small mb-0">
                            Cantidad de entradas vendidas por mes
                          </p>
                        </div>
                        <div className="card-body">
                          <div style={{ height: "300px" }}>
                            <BarChart data={resumen["ventas-entradas-mes"]} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="card-title mb-1">
                            Distribución por Salas
                          </h5>
                          <p className="card-text text-muted small mb-0">
                            Porcentaje de ventas por sala
                          </p>
                        </div>
                        <div className="card-body">
                          <div className="row" style={{ height: "300px" }}>
                            <div className="col-12 col-md-6">
                              <PieChart data={resumen["top-salas"]} />
                            </div>
                            <div className="col-12 col-md-6 d-flex flex-column justify-content-center">
                              {resumen["top-salas"].map((item, index) => (
                                <div
                                  key={index}
                                  className="d-flex justify-content-between align-items-center mb-3"
                                >
                                  <div className="d-flex align-items-center">
                                    <div
                                      className="rounded-circle me-2"
                                      style={{
                                        width: "12px",
                                        height: "12px",
                                        backgroundColor: [
                                          "#0ea5e9",
                                          "#f97316",
                                          "#8b5cf6",
                                          "#10b981",
                                          "#f59e0b",
                                        ][index % 5],
                                      }}
                                    />
                                    <span>{item.name}</span>
                                  </div>
                                  <span className="fw-medium">
                                    {item.value}%
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Details Tab */}
              {activeTab === "details" && (
                <div className="tab-pane fade show active">
                  {/* Filters */}
                  <div className="card border-0 shadow-sm mb-4">
                    <div className="card-body">
                      <div className="row mb-3">
                        <div className="col-12 col-md-6 col-lg-3 mb-3">
                          <div className="position-relative">
                            <Search
                              size={16}
                              className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                            />
                            <input
                              type="text"
                              className="form-control ps-5"
                              placeholder="Busca el nombre del evento o sala..."
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3 mb-3">
                          <select
                            className="form-select"
                            value={selectedProvince}
                            onChange={(e) =>
                              setSelectedProvince(e.target.value)
                            }
                          >
                            <option value="">Filtrar según la provincia</option>
                            <option value="cordoba">Córdoba</option>
                            <option value="buenos-aires">Buenos Aires</option>
                            <option value="mendoza">Mendoza</option>
                          </select>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3 mb-3">
                          <select
                            className="form-select"
                            value={selectedReport}
                            onChange={(e) => setSelectedReport(e.target.value)}
                          >
                            <option value="todos">Todos</option>
                            <option value="pendientes">Pendientes</option>
                            <option value="completados">Completados</option>
                          </select>
                        </div>

                        <div className="col-12 col-md-6 col-lg-3 mb-3">
                          <select
                            className="form-select"
                            value={selectedSort}
                            onChange={(e) => setSelectedSort(e.target.value)}
                          >
                            <option value="recent">Fecha más cercana</option>
                            <option value="oldest">Fecha más lejana</option>
                            <option value="highest">Mayor monto</option>
                            <option value="lowest">Menor monto</option>
                          </select>
                        </div>
                      </div>

                      <div className="row align-items-end">
                        <div className="col-12 col-md-8 mb-3">
                          <label className="form-label">Rango de fechas</label>
                          <div className="row">
                            <div className="col-6">
                              <div className="position-relative">
                                <Calendar
                                  size={16}
                                  className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                                />
                                <input
                                  type="date"
                                  className="form-control ps-5"
                                  onChange={(e) => {
                                    let filter = {
                                      ...params,
                                      fecha_desde: e.target.value
                                    }
                                    setParams({
                                      ...filter
                                    })
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="position-relative">
                                <Calendar
                                  size={16}
                                  className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                                />
                                <input
                                  type="date"
                                  className="form-control ps-5"
                                  onChange={(e) => {
                                    let filter = {
                                      ...params,
                                      fecha_hasta: e.target.value
                                    }
                                    setParams({
                                      ...filter
                                    })
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                          <button className="btn btn-warning w-100"
                            onClick={(e) => {
                              fetch(setDetalles, params, "/facturacion");
                            }}
                          >
                            <Filter size={16} className="me-2" />
                            Filtrar por rango de fecha
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Date Range Display */}
                  <div className="text-center text-muted small py-2 mb-3">
                    Desde 2024/06/02 hasta 2025/06/02
                  </div>

                  {/* Desktop Table View */}
                  <div className="d-none d-lg-block">
                    <div className="card border-0 shadow-sm">
                      <div className="table-responsive">
                        <table id="reportes-facturacion" className="table table-hover mb-0">
                          <thead className="table-light">
                            <tr>
                              <th>Id</th>
                              <th>Nombre Evento</th>
                              <th>Nombre Sitio</th>
                              <th>Email</th>
                              <th>Fecha de función</th>
                              <th className="text-end">Entradas vendidas</th>
                              <th className="text-end">Subtotal</th>
                              <th className="text-end">%</th>
                              <th className="text-end">Monto a abonar</th>
                              <th className="text-end">CBU</th>
                              <th className="text-end">CUIT</th>
                              <th className="text-end">Email</th>
                              <th>Descuento</th>
                              {/* <th>Entradas con descuento</th> */}
                              <th className="text-center">Opciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {detalles.data.map((account, index) => {

                              const liquidacion = [];

                              if (account.evento.liquidacion.length > 0) {
                                account.evento.liquidacion.map((liquidacionData) => {
                                  liquidacion.push(liquidacionData);
                                })
                              } else {
                                liquidacion.push({
                                  cbu: "Sin datos",
                                  entidad: "Sin datos",
                                  email_sitio: "Sin datos",
                                  porcentaje: "Porcentaje"
                                });
                              }
                              return (
                                <tr key={index}>
                                  <td className="fw-medium">
                                    {account.evento.id}
                                  </td>
                                  <td
                                    style={{ maxWidth: "200px" }}
                                    className="text-truncate"
                                  >
                                    {account.evento.nombre}
                                  </td>
                                  <td>{account.evento.nombre_sitio}</td>
                                  <td>{account.evento.email_sitio}</td>
                                  <td className="text-nowrap" title={account.fecha}>{account.fecha}</td>
                                  <td className="text-end">{account.cantidad}</td>
                                  <td className="text-end">
                                    {account.total}
                                  </td>
                                  <td className="text-end">
                                    <div style={{ display: "flex", flexDirection: "column", border: "0px solid #000" }}>
                                      {
                                        liquidacion.map((liquidacionData) => {
                                          return <div style={{ borderBottom: "0px solid #000", padding: "5px" }}>
                                            {liquidacionData.porcentaje}%
                                          </div>
                                        })
                                      }
                                    </div>
                                  </td>
                                  <td className="text-end">
                                    <div style={{ display: "flex", flexDirection: "column", border: "0px solid #000" }}>
                                      {
                                        liquidacion.map((liquidacionData) => {
                                          return <div style={{ borderBottom: "0px solid #000", padding: "5px" }}>
                                            {account.total * (liquidacionData.porcentaje / 100)}
                                          </div>
                                        })
                                      }
                                    </div>
                                  </td>
                                  <td className="text-end">
                                    <div style={{ display: "flex", flexDirection: "column", border: "0px solid #000" }}>
                                      {
                                        liquidacion.map((liquidacionData) => {
                                          return <div style={{ borderBottom: "0px solid #000", padding: "5px" }}>
                                            {liquidacionData.cbu}
                                          </div>
                                        })
                                      }
                                    </div>
                                  </td>
                                  <td className="text-end">
                                    <div style={{ display: "flex", flexDirection: "column", border: "0px solid #000" }}>
                                      {
                                        liquidacion.map((liquidacionData) => {
                                          return <div style={{ borderBottom: "0px solid #000", padding: "5px" }}>
                                            {liquidacionData.entidad}
                                          </div>
                                        })
                                      }
                                    </div>
                                  </td>
                                  <td className="text-end">
                                    <div style={{ display: "flex", flexDirection: "column", border: "0px solid #000" }}>
                                      {
                                        liquidacion.map((liquidacionData) => {
                                          return <div style={{ borderBottom: "0px solid #000", padding: "5px" }}>
                                            {liquidacionData.email_sitio}
                                          </div>
                                        })
                                      }
                                    </div>
                                  </td>
                                  <td>{formatCurrency(0)}</td>
                                  <td>
                                    <div className="d-flex justify-content-center gap-2">
                                      <button className="btn btn-warning btn-sm">
                                        Liquidar
                                      </button>
                                      <div className="dropdown">
                                        <button
                                          className="btn btn-outline-secondary btn-sm dropdown-toggle"
                                          type="button"
                                          data-bs-toggle="dropdown"
                                        >
                                          Opciones
                                        </button>
                                        <ul className="dropdown-menu">
                                          <li>
                                            <label className="dropdown-item" href="#">
                                              <Eye size={16} className="me-2" />
                                              Ver detalles

                                              <button
                                                className="d-none"
                                                name="detalle"
                                                onClick={(e) =>
                                                  onClick(e, account.reportes)
                                                }
                                                title="Detalle"
                                              ></button>
                                            </label>
                                          </li>
                                          <li>
                                            <label
                                              className="dropdown-item"
                                              style={{ cursor: 'pointer' }}
                                            >
                                              <Download
                                                size={16}
                                                className="me-2"
                                              />
                                              Descargar reporte
                                              <button
                                                className="d-none"
                                                name="download-reporte-individual"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  downloadReporte(account);
                                                }}
                                                title="Descargar Reporte"
                                              ></button>
                                            </label>
                                          </li>
                                          <li>
                                            <a className="dropdown-item" href="#">
                                              <Printer
                                                size={16}
                                                className="me-2"
                                              />
                                              Imprimir
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Card View */}
                  <div className="d-lg-none">
                    {mockAccountData.map((account, index) => (
                      <div key={index} className="card border-0 shadow-sm mb-3">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start mb-3">
                            <div>
                              <h6 className="fw-semibold mb-1">
                                {account.eventName}
                              </h6>
                              <p className="text-muted small mb-0">
                                {account.venueName}
                              </p>
                            </div>
                            <span className="badge bg-success bg-opacity-10 text-success border border-success">
                              ID: {account.id}
                            </span>
                          </div>

                          <div className="row g-2 small mb-3">
                            <div className="col-6">
                              <span className="text-muted">Fecha:</span>
                            </div>
                            <div className="col-6 text-end">
                              <span className="fw-medium">
                                {account.eventDate.split("HORA:")[0]}
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="text-muted">Hora:</span>
                            </div>
                            <div className="col-6 text-end">
                              <span className="fw-medium">
                                {account.eventDate.split("HORA:")[1]}
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="text-muted">Entradas:</span>
                            </div>
                            <div className="col-6 text-end">
                              <span className="fw-medium">
                                {account.ticketsSold}
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="text-muted">Subtotal:</span>
                            </div>
                            <div className="col-6 text-end">
                              <span className="fw-medium">
                                {formatCurrency(account.subtotal)}
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="text-muted">
                                Monto a abonar:
                              </span>
                            </div>
                            <div className="col-6 text-end">
                              <span className="fw-semibold text-success">
                                {formatCurrency(account.amountToPay)}
                              </span>
                            </div>
                          </div>

                          <div className="d-flex gap-2">
                            <button className="btn btn-warning btn-sm flex-fill">
                              Liquidar
                            </button>
                            <button className="btn btn-outline-secondary btn-sm flex-fill">
                              <Eye size={16} className="me-1" />
                              Detalles
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>


                  {modal_detalle ? (
                    <ModalDetalle
                      data={modal_detalle}
                      onClick={onClick}
                    />
                  ) : (
                    ""
                  )}
                </div>
              )}

              {/* Analytics Tab */}
              {activeTab === "analytics" && (
                <div className="tab-pane fade show active">
                  <div className="row">
                    <div className="col-12 col-lg-8 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="card-title mb-1">
                            Tendencia de Ventas
                          </h5>
                          <p className="card-text text-muted small mb-0">
                            Comparativa de ventas por trimestre
                          </p>
                        </div>
                        <div className="card-body">
                          <div style={{ height: "350px" }}>
                            <LineChart data={resumen["ingresos-mensuales"]} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-4 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="card-title mb-1">
                            Distribución de Ingresos
                          </h5>
                          <p className="card-text text-muted small mb-0">
                            Por tipo de evento
                          </p>
                        </div>
                        <div className="card-body">
                          <div style={{ height: "350px" }}>
                            <PieChart data={analisis["total-categoria"]} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-4 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="card-title mb-1">
                            Entradas por Día de Semana
                          </h5>
                          <p className="card-text text-muted small mb-0">
                            Distribución semanal
                          </p>
                        </div>
                        <div className="card-body">
                          <div style={{ height: "300px" }}>
                            <BarChart data={analisis["total-semanal"]} />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 col-lg-8 mb-4">
                      <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white">
                          <h5 className="card-title mb-1">
                            Rendimiento por Sala
                          </h5>
                          <p className="card-text text-muted small mb-0">
                            Ingresos por sala en los últimos 6 meses
                          </p>
                        </div>
                        <div className="card-body">
                          <div style={{ height: "300px" }}>
                            <BarChart data={analisis["redimiento-sala"]} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal Reportes */}
      {modal_reportes && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  <FileText size={20} className="me-2" />
                  Reportes de Facturación
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  name="close"
                  onClick={onClick}
                ></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-12">
                    <h6 className="fw-semibold mb-3">Generar Reporte</h6>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Tipo de Reporte</label>
                    <select className="form-select"
                      value={reporte.tipo_reporte}
                      onChange={(e) => {
                        setReporte({ ...reporte, tipo_reporte: e.target.value })
                      }
                      }>
                      <option value="general">Reporte General</option>
                      <option value="por-fecha-funcion">Por Fecha de funcion</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Formato</label>
                    <select className="form-select"
                      value={reporte.formato}
                      onChange={(e) => {
                        setReporte({ ...reporte, formato: e.target.value })
                      }
                      }>
                      <option value="excel">Excel</option>
                    </select>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className={`col-md-6 mb-3 ${reporte.tipo_reporte == 'general' ? '' : 'd-none'}`}>
                    <label className="form-label">Estado</label>
                    <select className="form-select"
                      onChange={(e) => {
                        setReporte({ ...reporte, estado: e.target.value })
                      }
                      }>
                      <option value="ACTIVO">Activo</option>
                      <option value="LIQUIDADO">Liquidado</option>
                      <option value="REEMBOLSADO">Reembolsado</option>
                    </select>
                  </div>
                  <div className={`col-md-6 mb-3 ${reporte.tipo_reporte == 'por-fecha-funcion' ? '' : 'd-none'}`}>
                    <label className="form-label">Estado</label>
                    <select className="form-select" onChange={(e) => {
                      setReporte({ ...reporte, estado: e.target.value })
                    }
                    }>
                      <option value="LIQUIDADO">Liquidado</option> <option value="ACTIVO">Sin Liquidar</option>
                    </select>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Fecha Desde</label>
                    <div className="position-relative">
                      <Calendar
                        size={16}
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                      />
                      <input
                        type="date"
                        className="form-control ps-5"
                        value={reporte.fecha_desde || ''}
                        onChange={(e) => {
                          setReporte({ ...reporte, fecha_desde: e.target.value })
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Fecha Hasta</label>
                    <div className="position-relative">
                      <Calendar
                        size={16}
                        className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                      />
                      <input
                        type="date"
                        className="form-control ps-5"
                        value={reporte.fecha_hasta || ''}
                        onChange={(e) => {
                          setReporte({ ...reporte, fecha_hasta: e.target.value })
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-12">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="includeDetails"
                        onChange={(e) => {
                          setReporte({ ...reporte, detalles: e.target.value })
                        }
                        }
                      />
                      <label className="form-check-label" htmlFor="includeDetails">
                        Incluir detalles de transacciones
                      </label>
                    </div>
                  </div>
                </div>

                <div className="alert alert-info d-flex align-items-center">
                  <FileText size={20} className="me-2" />
                  <small>
                    El reporte se generará con los datos actuales aplicando los
                    filtros seleccionados.
                  </small>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  name="close"
                  onClick={onClick}
                >
                  Cancelar
                </button>
                <button type="button" className="btn btn-warning"
                  name="download-reporte"
                  onClick={(e) => { onClick(e) }}
                >
                  <Download size={16} className="me-2" />
                  Generar Reporte
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Facturacion;
